import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false


// Position (0,1,2,3) to string filter
Vue.filter("positionToString", function(value) {
  if(value == null) return value;
  if (value > 3 || value < 0) return "";

  var positions = ["North", "East", "South", "West"];
  return positions[value];
});

// Position (0,1,2,3) to char filter
Vue.filter("positionToChar", function(value) {
  if(value == null) return value;
  if (value > 3 || value < 0) return "";

  var positions = ["N", "E", "S", "W"];
  return positions[value];
});

// Converts bids such as 1NT, 1C to the unicode version
Vue.filter("bidToString", function(value) {
  if(!value) return value;
  if (value == "PASS") return value;
  var result = value
    .replace("S", "♠")
    .replace("H", "♥")
    .replace("D", "♦")
    .replace("C", "♣");
  return result;
});

// Converts card to suit 1C -> 1 (without the suit)
Vue.filter("getNumber", function(value) {
  if(!value) return value;
  return value.substr(0, value.length - 1);
});

// Converts card to suit 1C -> club
Vue.filter("getSuit", function(value) {
  if(!value) return value;
  if (value == "NT") return value;
  var suits = {
    S: "♠",
    H: "♥",
    D: "♦",
    C: "♣",
  };
  var lastChar = value.substr(value.length - 1);
  return suits[lastChar];
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
